import { api } from "./api";

export const authService = {
  login: (email, password) =>
    api.post("/auth/login", { email, password }).then((r) => r.data),

  me: () => api.get("/auth/me").then((r) => r.data),

  logout: () => api.post("/auth/logout").then((r) => r.data),

  updateLanguage: (language) =>
    api.patch("/auth/me/language", { language }).then((r) => r.data),
};
